import RightsholderCatalogRegistrationDrafts from '@Scenes/RightsholderScene/RightsholderCatalogRegistrationDrafts'
import ViewWorkInternalScene from '@Scenes/WorkScenes/ViewWorkInternalScene'
import ViewDraftScene from '@Scenes/WorkScenes/ViewDraftScene'
import MatchScene from '@Scenes/RightsholderScene/MatchClaim/Match'
import React from 'react'
import createEditWorkRoutes from '@App/routes/rightsholder/editwork'
import Navigation from '@App/navigation'
import createMatchHistoryRoutes from '@App/routes/rightsholder/match-history'
import { PERMISSIONS } from '@Const/permissions'
import PermissionCheck from '@Components/Utility/PermissionCheck'
import { createEditDraftRoutes } from '@App/routes/rightsholder/editwork/draft'
import { FetchType } from '@App/kit/components/WorkItemV2/fetch-type-enum'
import RightsholderDashboard from '@Scenes/RightsholderScene/RightsholderDashboard'
import RightsholderCatalogLayout from '@Scenes/RightsholderScene/RightsholderCatalog/RightsholderCatalogLayout'
import RightsholderCatalogSearch from '@Scenes/RightsholderScene/RightsholderCatalog/RightsholderCatalogSearch'
import RightsholderOverclaimSearch from '@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch'
import RightsholderOverclaimLayout from '@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimLayout'
import ClaimWizardFlow from '@Scenes/RightsholderScene/MatchClaim/ClaimWizardFlow'
import OverclaimView from '@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView'
import OverclaimDocumentUploadPage from '@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/OverclaimDocumentUploadPage'
import { EDIT_DRAFT_ROUTE, EDIT_WORK_ROUTE, RIGHTSHOLDER_SUB_ROUTES } from '@App/navigation/route'
import { createRegistrationHistoryRoutes } from '@App/routes/rightsholder/registration-history'
import { createRoyaltiesRoutes } from '@App/routes/rightsholder/royalties'
import { createMaintenanceRoutes } from '@App/routes/rightsholder/maintenance'
import { createCatalogTransferRoutes } from '@App/routes/rightsholder/catalogtransfer'
import { createChangeRequestRoutes } from '@App/routes/rightsholder/change-requests'
import { createWorkMergeRoutes } from '@App/routes/rightsholder/workmerge'

const createRightsholderRootRoutes = () => {
    const editWorkRoutes = createEditWorkRoutes(EDIT_WORK_ROUTE)
    const editDraftRoutes = createEditDraftRoutes(EDIT_DRAFT_ROUTE)
    const matchHistoryRoutes = createMatchHistoryRoutes()
    const registrationHistoryRoutes = createRegistrationHistoryRoutes()
    const royaltiesRoutes = createRoyaltiesRoutes()
    const maintenanceRoutes = createMaintenanceRoutes()
    const catalogTransferRoutes = createCatalogTransferRoutes()
    const changeRequestRoutes = createChangeRequestRoutes()
    const workMergeRoutes = createWorkMergeRoutes()

    return {
        path: '',
        children: [
            {
                path: RIGHTSHOLDER_SUB_ROUTES.summary,
                element: <RightsholderDashboard />,
            },
            {
                path: '',
                element: (
                    <PermissionCheck
                        requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.manage_works]}
                        orIsInternal
                        reRouteLocation={Navigation.home.root()}
                    >
                        <RightsholderOverclaimLayout />
                    </PermissionCheck>
                ),
                children: [
                    {
                        path: RIGHTSHOLDER_SUB_ROUTES.overclaim.root,
                        element: <RightsholderOverclaimSearch />,
                    },
                    {
                        path: RIGHTSHOLDER_SUB_ROUTES.overclaim.view,
                        element: <OverclaimView />,
                    },
                    {
                        path: RIGHTSHOLDER_SUB_ROUTES.overclaim.uploadDocuments,
                        element: <OverclaimDocumentUploadPage />,
                    },
                ],
            },
            registrationHistoryRoutes,
            {
                path: RIGHTSHOLDER_SUB_ROUTES.drafts.root,
                element: (
                    <PermissionCheck
                        requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.manage_works]}
                        orIsInternal
                        reRouteLocation={Navigation.home.root()}
                    >
                        <RightsholderCatalogRegistrationDrafts />
                    </PermissionCheck>
                ),
            },
            {
                path: RIGHTSHOLDER_SUB_ROUTES.drafts.viewDraft,
                element: <ViewDraftScene />,
            },
            editWorkRoutes,
            {
                path: '',
                element: (
                    <PermissionCheck
                        requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.view_works]}
                        orIsInternal
                        reRouteLocation={Navigation.home.root()}
                    >
                        <RightsholderCatalogLayout />
                    </PermissionCheck>
                ),
                children: [
                    {
                        path: RIGHTSHOLDER_SUB_ROUTES.catalog.root,
                        element: <RightsholderCatalogSearch />,
                    },
                    changeRequestRoutes,
                    {
                        path: RIGHTSHOLDER_SUB_ROUTES.catalog.viewWork,
                        element: <ViewWorkInternalScene fetchType={FetchType.HFA} />,
                    },
                ],
            },
            {
                path: RIGHTSHOLDER_SUB_ROUTES.claimingTool,
                element: (
                    <PermissionCheck
                        requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.view_works]}
                        orIsInternal
                        reRouteLocation={Navigation.home.root()}
                    >
                        <ClaimWizardFlow />
                    </PermissionCheck>
                ),
            },
            {
                path: RIGHTSHOLDER_SUB_ROUTES.matchingTool,
                element: <MatchScene />,
            },
            matchHistoryRoutes,
            editDraftRoutes,
            ...royaltiesRoutes,
            ...maintenanceRoutes,
            catalogTransferRoutes,
            workMergeRoutes,
            {
                path: '',
                element: <RightsholderDashboard />,
            },
        ],
    }
}

export default createRightsholderRootRoutes
